// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AcceptRouteImport } from './routes/accept'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CentersRouteImport } from './routes/centers'
import { Route as ChartsRouteImport } from './routes/charts'
import { Route as CompatibilityReportRouteImport } from './routes/compatibility-report'
import { Route as CompatibilityVisualRouteImport } from './routes/compatibility-visual'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as GiftsRouteImport } from './routes/gifts'
import { Route as HdBasicsRouteImport } from './routes/hd-basics'
import { Route as HomeRouteImport } from './routes/home'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as MeRouteImport } from './routes/me'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WizardRouteImport } from './routes/wizard'
import { Route as AdminUtilitiesRouteImport } from './routes/admin/utilities'
import { Route as ChartsChartIdRouteImport } from './routes/charts/$chartId'
import { Route as ChartsSavedRouteImport } from './routes/charts/saved'
import { Route as ChartsSharedRouteImport } from './routes/charts/shared'
import { Route as WizardStepIdRouteImport } from './routes/wizard/$stepId'
import { Route as WizardReportLabRouteImport } from './routes/wizard/report-lab'
import { Route as AdminChartsChartIdRouteImport } from './routes/admin/charts/$chartId'
import { Route as CompatibilityFirstUsernameSecondUsernameRouteImport } from './routes/compatibility/$firstUsername/$secondUsername'
import { Route as CompatibilityWithUsernameRouteImport } from './routes/compatibility/with/$username'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AcceptRoute = AcceptRouteImport.update({
            id: '/accept',path: '/accept',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const CentersRoute = CentersRouteImport.update({
            id: '/centers',path: '/centers',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/centers.lazy').then((d) => d.Route))
const ChartsRoute = ChartsRouteImport.update({
            id: '/charts',path: '/charts',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/charts.lazy').then((d) => d.Route))
const CompatibilityReportRoute = CompatibilityReportRouteImport.update({
            id: '/compatibility-report',path: '/compatibility-report',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/compatibility-report.lazy').then((d) => d.Route))
const CompatibilityVisualRoute = CompatibilityVisualRouteImport.update({
            id: '/compatibility-visual',path: '/compatibility-visual',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/compatibility-visual.lazy').then((d) => d.Route))
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FriendsRoute = FriendsRouteImport.update({
            id: '/friends',path: '/friends',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/friends.lazy').then((d) => d.Route))
const GiftsRoute = GiftsRouteImport.update({
            id: '/gifts',path: '/gifts',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/gifts.lazy').then((d) => d.Route))
const HdBasicsRoute = HdBasicsRouteImport.update({
            id: '/hd-basics',path: '/hd-basics',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/hd-basics.lazy').then((d) => d.Route))
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/home.lazy').then((d) => d.Route))
const LearnRoute = LearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/learn.lazy').then((d) => d.Route))
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/library.lazy').then((d) => d.Route))
const MeRoute = MeRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/me.lazy').then((d) => d.Route))
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/sign-in.lazy').then((d) => d.Route))
const WizardRoute = WizardRouteImport.update({
            id: '/wizard',path: '/wizard',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/wizard.lazy').then((d) => d.Route))
const AdminUtilitiesRoute = AdminUtilitiesRouteImport.update({
            id: '/utilities',path: '/utilities',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/utilities.lazy').then((d) => d.Route))
const ChartsChartIdRoute = ChartsChartIdRouteImport.update({
            id: '/$chartId',path: '/$chartId',getParentRoute: () => ChartsRoute
          }).lazy(() => import('./routes/charts/$chartId.lazy').then((d) => d.Route))
const ChartsSavedRoute = ChartsSavedRouteImport.update({
            id: '/saved',path: '/saved',getParentRoute: () => ChartsRoute
          }).lazy(() => import('./routes/charts/saved.lazy').then((d) => d.Route))
const ChartsSharedRoute = ChartsSharedRouteImport.update({
            id: '/shared',path: '/shared',getParentRoute: () => ChartsRoute
          }).lazy(() => import('./routes/charts/shared.lazy').then((d) => d.Route))
const WizardStepIdRoute = WizardStepIdRouteImport.update({
            id: '/$stepId',path: '/$stepId',getParentRoute: () => WizardRoute
          }).lazy(() => import('./routes/wizard/$stepId.lazy').then((d) => d.Route))
const WizardReportLabRoute = WizardReportLabRouteImport.update({
            id: '/report-lab',path: '/report-lab',getParentRoute: () => WizardRoute
          }).lazy(() => import('./routes/wizard/report-lab.lazy').then((d) => d.Route))
const AdminChartsChartIdRoute = AdminChartsChartIdRouteImport.update({
            id: '/charts/$chartId',path: '/charts/$chartId',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/charts/$chartId.lazy').then((d) => d.Route))
const CompatibilityFirstUsernameSecondUsernameRoute = CompatibilityFirstUsernameSecondUsernameRouteImport.update({
            id: '/compatibility/$firstUsername/$secondUsername',path: '/compatibility/$firstUsername/$secondUsername',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/compatibility/$firstUsername/$secondUsername.lazy').then((d) => d.Route))
const CompatibilityWithUsernameRoute = CompatibilityWithUsernameRouteImport.update({
            id: '/compatibility/with/$username',path: '/compatibility/with/$username',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/compatibility/with/$username.lazy').then((d) => d.Route))





const AdminRouteChildren = {
  AdminUtilitiesRoute: AdminUtilitiesRoute,AdminChartsChartIdRoute: AdminChartsChartIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ChartsRouteChildren = {
  ChartsChartIdRoute: ChartsChartIdRoute,ChartsSavedRoute: ChartsSavedRoute,ChartsSharedRoute: ChartsSharedRoute
}

const ChartsRouteWithChildren = ChartsRoute._addFileChildren(ChartsRouteChildren)




const WizardRouteChildren = {
  WizardStepIdRoute: WizardStepIdRoute,WizardReportLabRoute: WizardReportLabRoute
}

const WizardRouteWithChildren = WizardRoute._addFileChildren(WizardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AcceptRoute: AcceptRoute,AdminRoute: AdminRouteWithChildren,CentersRoute: CentersRoute,ChartsRoute: ChartsRouteWithChildren,CompatibilityReportRoute: CompatibilityReportRoute,CompatibilityVisualRoute: CompatibilityVisualRoute,ContactRoute: ContactRoute,FriendsRoute: FriendsRoute,GiftsRoute: GiftsRoute,HdBasicsRoute: HdBasicsRoute,HomeRoute: HomeRoute,LearnRoute: LearnRoute,LibraryRoute: LibraryRoute,MeRoute: MeRoute,PrivacyRoute: PrivacyRoute,SignInRoute: SignInRoute,WizardRoute: WizardRouteWithChildren,CompatibilityFirstUsernameSecondUsernameRoute: CompatibilityFirstUsernameSecondUsernameRoute,CompatibilityWithUsernameRoute: CompatibilityWithUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)